module.exports = __webpack_public_path__ + "img/scheme-config.62d26305.svg";